// extracted by mini-css-extract-plugin
export var backButton = "sp3fM";
export var darkMode = "HzveM";
export var draggableRegion = "bILyE";
export var isDisabled = "aeIQx";
export var isInCompactMode = "FJmRM";
export var lightMode = "pzndE";
export var noScopePicker = "VCZ8z";
export var nonDraggableRegion = "b_3A1";
export var searchBox = "WPy_o";
export var searchBoxColumnContainer = "UXl34";
export var searchBoxCommonContainer = "x8k1J";
export var searchBoxContainer = "Q_UnC";
export var searchBoxContainerInSearch = "kDnI3";
export var searchBoxContainerNoBorderRadius = "sML3F";
export var searchButton = "Qfw_q";
export var searchIcon = "_7hUM";
export var searchQueryContainer = "gEOUV";
export var win32ParitySearchBoxAtRest = "wkO_1";
export var win32ParitySearchButton = "ZU_uB";
export var win32ParitySearchIcon = "Zd9fZ";